import React from 'react'
import { useEffect } from 'react'
import { createContext, useContextSelector } from 'use-context-selector'

import { useAppContextState } from 'app/@hooks'
import { BOOKING_SITES, SITE_STRING_EXCEPTIONS } from "app/@common/constants"
import { CompetitionAnalyzerSubmittedFiltersContext } from "../../../Providers"


const Context = createContext({})

const bookingSites = [
	BOOKING_SITES.APP, BOOKING_SITES.GENIUS, BOOKING_SITES.MOBILE, BOOKING_SITES.COM, BOOKING_SITES.MX, BOOKING_SITES.CN, BOOKING_SITES.BASIC, BOOKING_SITES.CORE,
	BOOKING_SITES.PAY, BOOKING_SITES.BR, BOOKING_SITES.PT, BOOKING_SITES.US, BOOKING_SITES.UK
];

const initialState = { checkElements: [] }

// ⚠️ i18n: `label`/`description` son IDENTIFICADORES ESTABLES en EN, NO texto visible.
// Múltiples consumidores filtran por `label` literal (p.ej. `checkElements.filter(a => a.label === 'Cancellation Policy')`)
// y varios `configMap` se indexan por ese label. Traducir el `label` aquí ROMPE esos lookups (la celda
// peta con `configX.isActive` sobre undefined). La traducción es DISPLAY-ONLY y vive en el render del chip
// (`tables/Checks/Checks.jsx`) vía `i18nKey`/`descriptionKey`. NO traducir `label`/`description` en este archivo.
export function CompetitionAnalyzerCheckElementsProvider({ children }) {
	const idSite = useContextSelector(CompetitionAnalyzerSubmittedFiltersContext, ({ state }) => state.id_site)

	const { state, updateState } = useAppContextState(initialState);

	useEffect(() => {
		updateState({ checkElements: [
			{
				label: 'Cancellation Policy', i18nKey: 'competition:misc.cancellationPolicy',
				isActive: false,
				visible: true,
				styleTag: {
					backgroundColor: '#12A3B9',
					color: '#FFF'
				}
			},
			{
				label: 'Meal plan', i18nKey: 'common:events.mealPlan',
				isActive: false,
				visible: true,
				styleTag: {
					backgroundColor: '#E0FF4F',
					color: '#000'
				}
			},
			{
				label: 'FRA', i18nKey: 'competition:misc.fra',
				description: 'Few Rooms Available', descriptionKey: 'competition:misc.fraDescription',
				isActive: false,
				visible: true,
				styleTag: {
					backgroundColor: '#80DB8F',
					color: '#000'
				}
			},
			{
				label: 'Loyalty', i18nKey: 'competition:misc.loyalty',
				description: 'Displays that a member price is available (shown prices may or may not apply then discount)', descriptionKey: 'competition:misc.loyaltyDescription',
				isActive: false,
				visible: true,
				styleTag: {
					backgroundColor: '#FFE45E',
					color: '#000'
				}
			},
			{
				label: '3rd Supplier', i18nKey: 'competition:misc.thirdSupplier',
				description: 'Displays rates through third party suppliers', descriptionKey: 'competition:misc.thirdSupplierDescription',
				isActive: false,
				visible: bookingSites.includes(idSite),
				styleTag: {
					backgroundColor: '#F79F79',
					color: '#000',
					display: bookingSites.includes(idSite) ? 'inline-block' : 'none'
				}
			},
			{
				label: 'Device', i18nKey: 'competition:misc.device',
				isActive: false,
				visible: SITE_STRING_EXCEPTIONS.OFFICIAL_SITE.toLowerCase() === idSite,
				styleTag: {
					backgroundColor: '#00D1C0',
					color: '#FFF',
					display: SITE_STRING_EXCEPTIONS.OFFICIAL_SITE.toLowerCase() === idSite ? 'inline-block' : 'none'
				}
			},
			{
				label: 'Booking Pay', i18nKey: 'competition:misc.bookingPay',
				description: 'Special deals for non direct payments', descriptionKey: 'competition:misc.bookingPayDescription',
				isActive: false,
				visible: bookingSites.includes(idSite),
				styleTag: {
					backgroundColor: '#2474B2',
					color: '#FFF',
					display: bookingSites.includes(idSite) ? 'inline-block' : 'none'
				}
			},
			{
				label: 'Channel', i18nKey: 'competition:misc.channel',
				isActive: false,
				visible: SITE_STRING_EXCEPTIONS.OFFICIAL_SITE.toLowerCase() === idSite,
				styleTag: {
					backgroundColor: '#2474B2',
					color: '#FFF',
					display: SITE_STRING_EXCEPTIONS.OFFICIAL_SITE.toLowerCase() === idSite ? 'inline-block' : 'none'
				}
			},
			{
				label: 'Room name', i18nKey: 'competition:misc.roomName',
				isActive: false,
				visible: true,
				styleTag: {
					backgroundColor: '#DBC9FF',
					color: '#000'
				}
			},
			{
				label: 'Room name Raw', i18nKey: 'competition:misc.roomNameRaw',
				isActive: false,
				visible: true,
				styleTag: {
					backgroundColor: '#8ABEE5',
					color: '#000'
				}
			},{
				label: 'Tax', i18nKey: 'competition:misc.tax',
				isActive: false,
				visible: true,
				styleTag: {
					backgroundColor: '#00D1C0',
					color: '#FFF',
				}
			},{
                label: 'Discount', i18nKey: 'competition:misc.discount',
                isActive: false,
                visible: true,
                styleTag: {
                    backgroundColor: '#FF6B6B',
                    color: '#FFF',
                }
            },{
                label: 'vs Main %', i18nKey: 'competition:misc.vsMainPercent',
                description: 'Shows the price difference vs the main hotel as a percentage under each cell', descriptionKey: 'competition:misc.vsMainPercentDescription',
                isActive: false,
                visible: true,
                styleTag: {
                    backgroundColor: '#9333EA',
                    color: '#FFF',
                }
            },
		]})
	}, [idSite, updateState]);

	return <Context.Provider value={{ state, updateState }}>
		{children}
	</Context.Provider>
}

export default Context;
